/**
 * Global terminology configuration for the application.
 * This allows easy switching between different terminology sets (e.g., donation vs tip).
 */

// Current terminology mode: "tip" or "donation"
const TERMINOLOGY_MODE = "tip";

// Define terminology mappings
const TERMINOLOGY = {
  tip: {
    // Nouns
    donation: "tip",
    donations: "tips",
    Donation: "Tip",
    Donations: "Tips",
    DONATION: "TIP",
    DONATIONS: "TIPS",
    
    // Verbs
    donate: "tip",
    donates: "tips",
    donating: "tipping",
    donated: "tipped",
    Donate: "Tip",
    Donating: "Tipping",
    Donated: "Tipped",
    DONATE: "TIP",
    DONATING: "TIPPING",
    DONATED: "TIPPED",
    
    // Agent nouns
    donator: "viewer",
    donators: "viewers",
    Donator: "Viewer",
    Donators: "Viewers",
    DONATOR: "VIEWER",
    DONATORS: "VIEWERS",
    
    // API/URL paths
    donationPath: "tip",
    donationsPath: "tips",
    donatorPath: "viewer",
    donatorsPath: "viewers",
  },
  donation: {
    // Keep original terminology
    donation: "donation",
    donations: "donations",
    Donation: "Donation",
    Donations: "Donations",
    DONATION: "DONATION",
    DONATIONS: "DONATIONS",
    
    donate: "donate",
    donates: "donates",
    donating: "donating",
    donated: "donated",
    Donate: "Donate",
    Donating: "Donating",
    Donated: "Donated",
    DONATE: "DONATE",
    DONATING: "DONATING",
    DONATED: "DONATED",
    
    donator: "donator",
    donators: "donators",
    Donator: "Donator",
    Donators: "Donators",
    DONATOR: "DONATOR",
    DONATORS: "DONATORS",
    
    donationPath: "donation",
    donationsPath: "donations",
    donatorPath: "donator",
    donatorsPath: "donators",
  }
};

// Helper function to get current terminology
export const getTerm = (key) => {
  return TERMINOLOGY[TERMINOLOGY_MODE][key] || key;
};

// Export commonly used terms
export const terms = {
  donation: getTerm("donation"),
  donations: getTerm("donations"),
  Donation: getTerm("Donation"),
  Donations: getTerm("Donations"),
  DONATION: getTerm("DONATION"),
  DONATIONS: getTerm("DONATIONS"),
  
  donate: getTerm("donate"),
  donating: getTerm("donating"),
  donated: getTerm("donated"),
  Donate: getTerm("Donate"),
  Donating: getTerm("Donating"),
  Donated: getTerm("Donated"),
  DONATE: getTerm("DONATE"),
  
  donator: getTerm("donator"),
  donators: getTerm("donators"),
  Donator: getTerm("Donator"),
  Donators: getTerm("Donators"),
  DONATOR: getTerm("DONATOR"),
  DONATORS: getTerm("DONATORS"),
  
  // API paths
  donationPath: getTerm("donationPath"),
  donationsPath: getTerm("donationsPath"),
  donatorPath: getTerm("donatorPath"),
  donatorsPath: getTerm("donatorsPath"),
};

export default terms;